export default __webpack_public_path__ + "static/media/DesignInstructionsforSticker.87f60c85.pdf";